export default __webpack_public_path__ + "static/media/logo-dark.8b814112.png";